import React, { useState, useEffect, useCallback } from 'react';
import Button from 'carbon-components-react/lib/components/Button';
import { useHistory } from 'react-router-dom';

import * as Constants from '../../requests/URLConstants';
import callPostApi from "../../requests/PostRequests";
import RunAutomata from 'assets/image/Automation_Leadspaces_FINAL_Services.svg';
import i18n from "../../i18n";

require("./_run-automata.scss");


function redirect() {
    window.location.href = "/manage_operations";
}
const CompletedRunAutomata = props => {
    const ManageOperations = i18n.t('runAutomata.manageOperations');
    const ScheduleCreation = i18n.t('scheduleRecommendation.RunAutomataCreation');
    //const ExecutionStatus = i18n.t('scheduleRecommendation.ExecutionStatus');
    const ChkRunStatus = i18n.t('scheduleRecommendation.ChkRunStatus');
    const sessionNo = i18n.t('scheduleRecommendation.sessionNo');
    const[sessionNumber, setSessionNumber] = useState('');
    const history = useHistory();
    let user = JSON.parse(localStorage.getItem('user_name'));
    console.log(user);
    
    function RunAutomataTriggeredBy() {
        let bodyJson = {
            JobId: props.location.session_no,
            User: user
        }
        callPostApi(Constants.RUNAUTOMATATRIGGEREDBY, {
            'Content-Type': 'application/json'
        }, bodyJson).then(resp => {
            if (resp) {
                console.log(resp);
                //setSessionNumber(resp.sessionNo);
                
            }
        }).catch((error) => {
            //setAutomataLoading(false);
        });
    }

    useEffect(() => {
        // RunAutomataTriggeredBy();
    })
    return (
        <div className="page-margin padding-top-30px">

            <div className="add-new-code-page-margin">
                <div className="add-new-main-run-automata">
                    <div className="add-new-main-segment-image"><img src={RunAutomata} alt="" /></div>
                    <div className="add-new-main-segment">
                        <ul className="font-success carbon-display-Regular-28">{ScheduleCreation}</ul>
                        <ul className="font-success carbon-display-Regular-20">{sessionNo}
                            <li> {props.location.session_no} </li> </ul>
                        <ul className="font-success carbon-display-Regular-20">{ChkRunStatus}</ul>
                        {/* <ul className="font-success carbon-display-Regular-20">{ExecutionStatus}</ul> */}
                        <ul><Button className="add-new-main-segment-button" kind="tertiary" onClick={redirect} >{ManageOperations}</Button></ul>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default CompletedRunAutomata;